import React, {useEffect, useState} from "react";
import dynamic from 'next/dynamic'
import {
    convertNumber,
    getColor,
    getBahabinText,
    getSignWithPercent,
    getTodayJalaliDate, getSymbolFromFullSymbol
} from "../../../util/DominantUtil";
import {Helmet} from "react-helmet";
import {useGlobalEnergyGlobalState} from "../../../components/store/EnergyGlobalState";
import {useSymbolsGlobalState} from "../../../components/store/SymbolsMetaDataState";

const BoxDynamicComponent = dynamic(() => import('../../../components/box/Box'))
const TableVirtualizedDynamicComponent = dynamic(() => import('../../../components/virtualized/virtualized'))

export default function Watchlist(response) {
    const [energyList, refreshEnergyList] = useGlobalEnergyGlobalState(state => [state.energyList, state.refreshEnergyList]);
    const [symbolsGlobalCache, refreshSymbolsCache] = useSymbolsGlobalState(state => [state.cache, state.refreshCache]);

    const [autoScrollIntervalId] = useState(null)
    const [tableBgColor, setTableBgColor] = useState('bg-white');
    const scrollToIndex = null

    useEffect(() => {
        refreshSymbolsCache();
        symbolsGlobalCache && refreshEnergyList(symbolsGlobalCache)
    }, [symbolsGlobalCache])

    function handleSwitchDark(value) {
        return setTableBgColor(value ? 'bg-dark' : 'bg-white')
    }

    const properties = {
        checkedDark: false,
        switchDarkBackground: true,
        handleSwitchDark: handleSwitchDark,
        help: {
            title: 'دیده بان بازار فارکس',
            content: `      امکانات:
            نمایش تابلو معاملات
            `
        }
    };

    const tooltipSteps = [
        {
            target: '.extraDarkTheme',
            content: 'تغییر رنگ پس زمینه به سیاه',
            placement: 'right',
        }
    ]

    const description = `با استفاده از بهابین لیست قیمت بازار انرژی را مشاهده کنید`
    const title = `قیمت لحظه ای بازار انرژی`

    return (
        <BoxDynamicComponent uiActions={properties} loaded={energyList}
                             heading={`نرخ و نوسانات بازار انرژی ${getTodayJalaliDate()}`}
                             height='930px'
                             leftBoxClassName={'w-100'}
                             linksMap={{
                                 'last': 'بازار انرژی',
                             }}
                             tooltipSteps={tooltipSteps}>
            <Helmet
                title={'قیمت امروز خرید و فروش بازار انرژی' + getBahabinText()}
                meta={[{name: 'description', content: description}, {
                    property: 'twitter:description',
                    content: description
                }, {property: 'og:title', content: title}]}
            />
            <TableVirtualizedDynamicComponent
                market="energy"
                columns={sourceColumn}
                customHeight={890}
                mutableData={energyList?.data}
                keyField="s"
                numberFormat={true}
                scrollToIndex={scrollToIndex}
                setBgClassName={(x) => tableBgColor}
            />
        </BoxDynamicComponent>
    );
};

const sourceColumn = [
    {
        title: "شاخص",
        dataIndex: "faN",
        sorter: true,
        enable: true,
    },
    {
        title: "نماد",
        dataIndex: "s",
        type: 'link',
        renderer: getSymbolFromFullSymbol,
        sorter: true,
        enable: true,
    },
    {
        title: "قیمت",
        dataIndex: "c",
        sorter: true,
        enable: true,
    },
    {
        title: "تغییر",
        dataIndex: "P",
        suffix: '%',
        renderer: lastChangeRenderer,
        colorRenderer: getColor,
        sorter: true,
        enable: true,
    },
    {
        title: "کمترین",
        dataIndex: "l",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    },
    {
        title: "بیشترین",
        dataIndex: "h",
        sorter: true,
        enable: true,
        disableOnMobile: true,
    }
]

function lastChangeRenderer(v) {
    return getSignWithPercent(v, 2)
}

function bigNumberFormat(v) {
    return convertNumber(v, 0)
}